<template>
  <v-sheet height="100%" class="neu-glow-inset">
    <v-container class="fill-height justify-center" fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" sm="9" md="6">
          <v-sheet class="neu-glow with-radius fill-height" height="100%">
            <v-img
              src="/static/ob-animated-isometric/logout-animate.svg"
              lazy-src="/static/ob-animated-isometric/logout-animate.svg"
              height="400"
              contain
            >
            </v-img>
            <v-row justify="end" class="fill-height">
              <v-col class="text-center px-10" cols="12">
                <h3 class="mb-1">
                  {{$t(page+'.localStorage and sessionStorage are disabled in your browser')}}
                </h3>                
              </v-col>
              <v-col class="text-center px-10" cols="12">
                <div class="text-body-1 mb-5">
                  {{$t(page+'.Cannot Continue')}} <br />
                  {{$t(page+'.Check here for instructions how to Enable it')}} <br />
                  <v-btn class="my-2"><a target="_blank" href="https://techglimpse.com/enable-localstorage-support-google-chrome-browser/">link</a></v-btn>
                  <br />
                   {{$t(page+'.enable localStorage and sessionStorage and try Login again')}}
                </div>
                <v-btn
                  color="secondary"
                  to="/"
                  class="mb-5"
                  >{{$t(page+'.Login Again')}}</v-btn
                >
              </v-col>
            </v-row>
          </v-sheet>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>


<script>

export default {
  created(){
    sessionStorage.removeItem('jwt');
    sessionStorage.removeItem('jwt_b');
    localStorage.removeItem('user_b');
  },
  data() 
  {
    return {
      page:'Auth'
    }
  }
};
</script>
